<ng-container *transloco="let t; read: 'SURVEY_CAMPAIGN_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <div class="left"></div>
      <h1>{{ t('TITLE') }}</h1>
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <form class="select-container">
      <app-form-control class="mt-4">
        <app-select
          [placeholder]="t('PICK_YOUR_RESTAURANT')"
          mode="select"
          [formControl]="innerControl"
          [options]="restaurants"
          [valueFn]="valueFn"
          [displayFn]="displayFn"
        >
        </app-select>
      </app-form-control>
    </form>

    <div class="survey-slide" *ngLet="restaurant?.surveyDS$ | async; let surveyDS">
      @if (surveyDS && surveyDS.loading) {
        <app-pre-loader *ngIf="surveyDS?.loading" class="flex flex-center"> </app-pre-loader>
      } @else if (surveyDS && surveyDS.error) {
        <app-error-container icon="warning" [errorKey]="surveyDS.error.errorKey" class="error-container mt-24"> </app-error-container>
      } @else {
        <app-survey-campaign-form [restaurant]="restaurant" [survey]="surveyDS?.data"> </app-survey-campaign-form>
      }
    </div>
  </ion-content>
</ng-container>
